// CANONICAL COPY (GH #7115). src/constants/obligations/obl-access-rights-review.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-access-rights-review',
  title: 'Review user access rights',
  description:
    'Review all user access rights and remove unnecessary privileges. Verify that access rights align with current roles and responsibilities. Covers full identity lifecycle — provisioning, modification and revocation. Where Entra ID is connected, no active account may be stale beyond the configured threshold and every privileged admin must have MFA enabled.',
  category: 'access',
  scfIds: ['SCF-IAM-004', 'SCF-IAM-002'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'employees-access-revoked', description: 'All leavers have had access revoked' },
    {
      type: 'jml-process-complete',
      jmlType: 'leave',
      description: 'All leaver JML processes are completed',
    },
    {
      type: 'entra-stale-accounts-clear',
      description: 'No Entra-synced active employee is stale beyond the configured threshold',
    },
    {
      type: 'privileged-mfa-enrolled',
      description: 'Every privileged Entra admin has MFA enabled',
    },
    {
      type: 'uar-campaign-completed',
      description:
        'A User Access Review campaign has been closed with a verified evidence report that has not expired. Fails closed when no campaign has been run, and when a closed campaign carries no expiry date (GH #6661) — a review is a recurring activity, so an undated one evidences nothing.',
    },
  ],
  domainActions: [{ type: 'deep-link', target: 'employees', label: 'Review Employee Records' }],
};
